import { screen } from "@testing-library/react";
import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import { SidebarContext } from "../../componentes/sidebarContext";
import { Slider } from "../../componentes/slider";
import menu from '../../rotas/menu'

const base = window.location.host;
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };}
export function HeaderPagina() {
  const {isOpen,toggle} = useContext(SidebarContext)


    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [window.location]);
  const [fixed, SetFixed] = useState(false);
  useEffect(() => {
    const handleScroll = event => {
      SetFixed(window.scrollY > 200)
    };
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);


    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);

    };
  }, []);

  return (<>
    <header>
      <div className={fixed ? 'ui sticky fixed nav-menu pagina ' : 'ui nav-menu pagina'}>
        <div className="ui container">
          <div className="ui menu secondary">
            <Link to="/" className="item logo"><img src="./logo.png" /></Link>
            <div className="menu right">

              {windowDimensions.width < 800 ?
               <>
                   <div className="item sidebar" onClick={() => toggle(!isOpen)} >
            <i className="sidebar icon"></i>
          </div>
              </> : <>
              {menu?.map((menu , i ) => (
                <>
                {menu.nav && 
                  <Link key={i} className={`ui item ${menu?.drop?.length > 0 ? 'dropdown simple' : ''}`}  to={menu.path} >
                    <span className="text">{menu?.titulo}</span>
                    {menu?.drop &&
                      <div class="menu">
                        {menu?.drop.map(drop => (
                          <Link className="item" to={drop.path} >{drop.titulo}</Link>
                        ))}
                      </div>
                    }

                  </Link>
}
                </>
              ))}
              </>


              }
         
              <a className="item estilo" target="_blank" href="https://paguejaonline.com.br/">PagueJá</a>
            </div>
          </div>
        </div>
      </div>
    </header>



  </>)
}